/**
 * Right-hand action cluster for a list row: flex, wraps, right-aligned, even gaps.
 * Replaces the old "every button in its own <Col>" layouts that collided/wrapped badly.
 */
export default function AdminActions({ className = "", children }) {
  return <div className={`admin-actions ${className}`.trim()}>{children}</div>;
}
